module.exports = __webpack_public_path__ + "img/Shymkent.fa57b7ae.png";